module.exports = __webpack_public_path__ + "img/top.9416c3ad.svg";